var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.canEdit && !_vm.item._editing
        ? _c(
            "b-btn-group",
            [
              _vm.item.is_packed
                ? _c(
                    "b-btn",
                    {
                      staticClass: "save-row-toggle",
                      attrs: {
                        size: "xs",
                        variant: "primary",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleIsPacked(_vm.item)
                        },
                      },
                    },
                    [
                      !_vm.item._toggling
                        ? _c("i", { staticClass: "fas fa-undo" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item._toggling
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.item.is_packed
                ? _c(
                    "b-btn",
                    {
                      staticClass: "save-row-toggle",
                      attrs: {
                        size: "xs",
                        variant: "success",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleIsPacked(_vm.item)
                        },
                      },
                    },
                    [
                      !_vm.item._toggling
                        ? _c("i", { staticClass: "fas fa-check" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item._toggling
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canEdit && _vm.item.is_private
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "xs",
                        variant: "secondary",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.startEditItem(_vm.item)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-edit" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canEdit && _vm.item.is_private
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "xs",
                        variant: "danger",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteItem(_vm.item)
                        },
                      },
                    },
                    [
                      !_vm.item._deleting
                        ? _c("i", { staticClass: "fas fa-trash" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item._deleting
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canEdit && _vm.item._editing
        ? _c(
            "b-btn-group",
            [
              _vm.canEdit
                ? _c(
                    "b-btn",
                    {
                      staticClass: "save-row-toggle",
                      attrs: {
                        size: "xs",
                        variant: "primary",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.finishEditItem(_vm.item)
                        },
                      },
                    },
                    [
                      !_vm.item._saving
                        ? _c("i", { staticClass: "fas fa-save" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item._saving
                        ? _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canEdit
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "xs",
                        variant: "outline-danger",
                        disabled: _vm.item._saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.cancelEditItem(_vm.item)
                        },
                      },
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }